'use strict';

var react = require('react');
var EnvContext = require('./EnvContext.cjs');

const useEnv = () => {
  const context = react.useContext(EnvContext.EnvContext);
  if (context === null) {
    throw new Error("\uCEF4\uD3EC\uB10C\uD2B8 \uC0C1\uC704\uC5D0 EnvContextProvider\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.");
  }
  return context;
};

exports.useEnv = useEnv;
//# sourceMappingURL=useEnv.cjs.map
